module.exports = __webpack_public_path__ + "static/kapitola_09_small-31c82422f569a82e5d4a2146a6497a89.jpg";